/* eslint-disable */

import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import DescriptionIcon from '@mui/icons-material/Description';
import TableChartIcon from '@mui/icons-material/TableChart';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import VideoFileOutlinedIcon from '@mui/icons-material/VideoFileOutlined';

export const MESSAGES_PER_PAGE = 100;
export const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10 MB
export const QUICK_REACTIONS = ['👍', '❤️', '😂', '😮', '😢', '😡', '🔥', '👏'];

export const getFileCategory = (fileType) => {
  if (!fileType) return 'other';
  if (fileType.startsWith('image/')) return 'image';
  if (fileType.startsWith('video/')) return 'video';
  if (fileType === 'application/pdf') return 'pdf';
  if (
    fileType.includes('spreadsheet') ||
    fileType.includes('excel') ||
    fileType === 'text/csv'
  )
    return 'excel';
  if (fileType.includes('word') || fileType.includes('document')) return 'word';
  return 'other';
};

export const getFileIconConfig = (category) => {
  switch (category) {
    case 'pdf':
      return { Icon: PictureAsPdfIcon, color: '#E53935' };
    case 'excel':
      return { Icon: TableChartIcon, color: '#388E3C' };
    case 'word':
      return { Icon: DescriptionIcon, color: '#1565C0' };
    case 'image':
      return { Icon: ImageOutlinedIcon, color: '#6A1B9A' };
    case 'video':
      return { Icon: VideoFileOutlinedIcon, color: '#EF6C00' };
    default:
      return { Icon: InsertDriveFileIcon, color: '#546E7A' };
  }
};

export const formatFileSize = (bytes) => {
  if (!bytes) return '';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

export const formatTime = (timestamp) => {
  if (!timestamp) return '';
  const date = new Date(timestamp);
  const now = new Date();
  const diffMs = now - date;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);
  if (diffMins < 1) return 'Just now';
  if (diffMins < 60) return `${diffMins}m`;
  if (diffHours < 24) return `${diffHours}h`;
  if (diffDays < 7) return `${diffDays}d`;
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
};

export const formatFullTime = (timestamp) => {
  if (!timestamp) return '';
  return new Date(timestamp).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  });
};

export const groupReactions = (reactions = [], currentUserId) => {
  const map = {};
  reactions.forEach(({ userId, emoji }) => {
    if (!map[emoji]) map[emoji] = { count: 0, hasReacted: false, names: [] };
    map[emoji].count++;
    const uid = userId?._id ?? userId;
    const fname = userId?.fname ?? '';
    const lname = userId?.lname ?? '';
    const name = `${fname} ${lname}`.trim() || 'Unknown';
    if (uid && String(uid) === String(currentUserId)) {
      map[emoji].hasReacted = true;
      map[emoji].names.unshift('You');
    } else {
      map[emoji].names.push(name);
    }
  });
  return map;
};

export const uploadChatFile = (file, chatId, onProgress) => {
  return new Promise((resolve, reject) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('chatId', chatId);
    const token = localStorage.getItem('user')
      ? JSON.parse(localStorage.getItem('user')).token
      : null;
    const xhr = new XMLHttpRequest();
    xhr.open('POST', `${process.env.REACT_APP_SERVER_URL}/api/chat/upload`, true);
    if (token) xhr.setRequestHeader('Authorization', `Bearer ${token}`);
    xhr.upload.onprogress = (e) => {
      if (e.lengthComputable) onProgress(Math.round((e.loaded / e.total) * 100));
    };
    xhr.onload = () => {
      if (xhr.status === 200) {
        try {
          resolve(JSON.parse(xhr.responseText));
        } catch {
          reject(new Error('Invalid server response'));
        }
      } else {
        try {
          const err = JSON.parse(xhr.responseText);
          reject(new Error(err.message || 'Upload failed'));
        } catch {
          reject(new Error(`Upload failed (${xhr.status})`));
        }
      }
    };
    xhr.onerror = () => reject(new Error('Network error during upload'));
    xhr.send(formData);
  });
};

export const downloadFileWithProgress = (s3Key, fileName, messageId, setDownloadProgress) => {
  if (!s3Key) return;
  setDownloadProgress((prev) => ({ ...prev, [messageId]: 0 }));
  const token = localStorage.getItem('user')
    ? JSON.parse(localStorage.getItem('user')).token
    : null;
  const xhr = new XMLHttpRequest();
  xhr.responseType = 'blob';
  const downloadUrl = `${process.env.REACT_APP_SERVER_URL}/api/chat/download?key=${encodeURIComponent(s3Key)}&name=${encodeURIComponent(fileName)}`;
  xhr.open('GET', downloadUrl, true);
  if (token) xhr.setRequestHeader('Authorization', `Bearer ${token}`);
  xhr.onprogress = (e) => {
    if (e.lengthComputable) {
      const pct = Math.round((e.loaded / e.total) * 100);
      setDownloadProgress((prev) => ({ ...prev, [messageId]: pct }));
    }
  };
  xhr.onload = () => {
    if (xhr.status === 200) {
      const blobUrl = URL.createObjectURL(xhr.response);
      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
    }
    setDownloadProgress((prev) => {
      const next = { ...prev };
      delete next[messageId];
      return next;
    });
  };
  xhr.onerror = () => {
    setDownloadProgress((prev) => {
      const next = { ...prev };
      delete next[messageId];
      return next;
    });
  };
  xhr.send();
};
